// extracted by mini-css-extract-plugin
module.exports = {"root":"Pagination_root__4bneo","pagination":"Pagination_pagination__ZlveS","paginationControls":"Pagination_paginationControls__16S4C"};